import Scriba from 'react-scriba';

export class DataChampMetier {

    static _lister = (filtres, sortedColumn, isSortedDescending) => {
        const objet = { filtres, sortedColumn, isSortedDescending };
        const url = "api/Liste/ListerChampMetier";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _detailler = (idChampMetier) => {
        const objet = { idChampMetier };
        const url = "api/Fiche/DetaillerChampMetier";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _enregistrer = (champMetier) => {
        const objet = { champMetier };
        const url = "api/MajDonnees/EnregistrerChampMetier";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _supprimer = (idChampMetier) => {
        const objet = { idChampMetier };
        const url = "api/MajDonnees/SupprimerChampMetier";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

};